module.exports = __webpack_public_path__ + "img/icon_map_108_on_010.23d76589.png";